"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useEffect } from "react";
import OtpInput from "react-otp-input";
import { isDesktop } from "@/app/utils/detectDevice";
import cn from "@/app/utils/cn";
import changeNumToEng from "@/app/utils/persianNumToEnglish";
function IOtpInput(t0) {
  const $ = _c(20);
  const {
    inputValue,
    inputOnchange,
    customStyle
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = function transformTEngilsh(rawVaule) {
      const value = changeNumToEng(rawVaule).replace(/[^0-9]/g, "");
      return value;
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const transformTEngilsh = t1;
  let t2;
  if ($[1] !== inputOnchange) {
    t2 = event => {
      const data = transformTEngilsh(event.clipboardData.getData("text")).replace(/[^0-9]/g, "");
      inputOnchange(data);
    };
    $[1] = inputOnchange;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handlePaste = t2;
  let t3;
  if ($[3] !== inputOnchange) {
    t3 = otp => {
      const data_0 = transformTEngilsh(otp);
      inputOnchange(data_0);
    };
    $[3] = inputOnchange;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const handleChange = t3;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = (event_0, onChange) => {
      const nativeEvent = event_0.nativeEvent as InputEvent;
      const data_1 = nativeEvent.data ?? "";
      if (!data_1) {
        return;
      }
      const normalized = transformTEngilsh(data_1);
      if (!normalized || normalized.length !== 1) {
        return;
      }
      if (normalized === data_1) {
        return;
      }
      event_0.preventDefault();
      onChange?.({
        target: {
          value: normalized
        }
      } as React.ChangeEvent<HTMLInputElement>);
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const handleBeforeInput = t4;
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = new AbortController();
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const controller = t5;
  const {
    signal
  } = controller;
  let t6;
  if ($[7] !== inputOnchange) {
    t6 = async () => {
      if ("OTPCredential" in window) {
        ;
        try {
          await navigator.credentials.get({
            otp: {
              transport: ["sms"]
            },
            signal
          }).then(otp_0 => {
            if (otp_0?.type === "otp" && otp_0.code) {
              inputOnchange(otp_0.code);
            } else {
              console.log("No OTP code received.");
            }
          });
        } catch (t7) {
          const err = t7;
          console.error("Error in OTP retrieval:", err);
        }
      } else {
        console.log("Web OTP API is not supported in this browser.");
      }
    };
    $[7] = inputOnchange;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const fetchOTP = t6;
  let t7;
  if ($[9] !== fetchOTP) {
    t7 = () => {
      if (!isDesktop()) {
        fetchOTP().then(_temp);
      }
      return () => {
        controller.abort();
      };
    };
    $[9] = fetchOTP;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = [];
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  useEffect(t7, t8);
  let t9;
  if ($[12] !== customStyle) {
    t9 = cn("border border-charcoal-200 rounded-lg w-full outline-none focus-within:border-bluetiful-400 !w-10 !h-8 xl:!w-18 xl:!h-12", customStyle);
    $[12] = customStyle;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = props => <input ref={props.ref} value={props.value} onChange={props.onChange} onFocus={props.onFocus} onBlur={props.onBlur} onKeyDown={props.onKeyDown} onPaste={props.onPaste} onInput={props.onInput} aria-label={props["aria-label"]} autoComplete="one-time-code" style={props.style} inputMode={props.inputMode} placeholder={props.placeholder} className={props.className} type={props.type} onBeforeInput={event_1 => handleBeforeInput(event_1, props.onChange)} />;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== handleChange || $[16] !== handlePaste || $[17] !== inputValue || $[18] !== t9) {
    t11 = <div dir="ltr" className="font-en"><OtpInput value={inputValue} onChange={handleChange} onPaste={handlePaste} numInputs={6} inputType="number" inputStyle={t9} containerStyle="w-full flex justify-between gap-x-2 md:gap-x-3" renderInput={t10} shouldAutoFocus={true} /></div>;
    $[15] = handleChange;
    $[16] = handlePaste;
    $[17] = inputValue;
    $[18] = t9;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  return t11;
}
function _temp(r) {}
export default React.memo(IOtpInput);